import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import home from './components/Home.vue';
import room from './components/Room.vue';
import directRoomLogin from './components/DirectRoomLogin.vue';
import notFound from './components/404.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: home
  },
  {
    path: '/room/:slug',
    name: 'Login',
    component: directRoomLogin
  },
  {
    path: '/entered/:slug',
    name: 'Room Name',
    component: room
  },
  { path: '*', 
    name: 'Not Found',
    component: notFound 
  }
]


const router = new VueRouter({
  mode: 'history',
  routes // short for `routes: routes`
})

export default router;
